import * as React from 'react'

import { Box, Button, Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  show: boolean
  readonly?: boolean
  onAddMembers: () => void
}

const BlankState = ({ show, readonly, onAddMembers }: Props) => {
  if (!show) {
    return null
  }

  return (
    <>
      <Table.Row>
        <Table.Cell colSpan={5}>
          <Box alignItems="center" justifyContent="center" padding="s24" textAlign="center">
            <Text.Normal>{i18n.t('teams.members.blank_description')}</Text.Normal>
            {!readonly && (
              <Box paddingTop="s32">
                <Button type="secondary" onClick={onAddMembers}>
                  {i18n.t('teams.members_modal.title')}
                </Button>
              </Box>
            )}
          </Box>
        </Table.Cell>
      </Table.Row>
    </>
  )
}

export default observer(BlankState)
